<template>
    <div>
        <div >
            <div v-for="(row, index) in list" :key="index" class="grid grid-cols-4 mb-6 pr-9">
                <div class="w-full flex flex-col items-center justify-center">
                    <div>
                        <div class="bg-circle rounded-full w-5 h-5 box-content mb-4"></div>
                    </div>
                    
                    <div class="w-0.5 h-full bg-red-100 "></div>
                </div>
                
                <div class="grid grid-rows-1 col-span-3">
                    <div class="font-bold text-xl mb-2">
                        {{ row.title }}
                    </div>
                    <div class="font-normal text-xl">{{ row.description }}</div>
                    <div class="font-thin text-xl">{{ row.date }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "HistoricalLineComponent",
    props: {
        list: {
            type: Array,
            default(){
                return [];
            }
        },
        view_class_view:{
            type: Object,
            default(){
                return {};
            }
        }
    },
    setup(){
        return {};
    }
}

</script>

<style>
.bg-circle {
    background-color: #69D4AC;
}
</style>